/**
* Load Modules
*/

require('../css/main.scss');

window.onload = function() {document.body.scrollTop = document.documentElement.scrollTop = 0;};

var app = {
	init: function(){

		if($('.gMap').length){
			map = new GMaps({
			div: '.gMap',
			lat: 51.508216,
			lng: -0.193622,
			zoom: 16,
			scrollwheel: false
		  });
		  map.addMarker({
			lat: 51.508216,
			lng: -0.193622,
			title: 'Chassay Studio',
			click: function(e){
					var url = 'https://www.google.co.uk/maps/place/Chassay+Studio/@51.5086044,-0.1956174,17z/data=!3m1!4b1!4m5!3m4!1s0x48760ff96093e957:0x66b6be7949fb45e0!8m2!3d51.5086044!4d-0.1934287';
			  window.open(url,'_blank');
			}
		  });
		}

		$(".revealProjectDetails").on("click", function(e){
			$(this).parent().find(".projectDetails").slideToggle('slow');
			$(this).parent().find(".projectDetailsGrid").toggleClass('active');
			if($(this).hasClass('open')){
				$(this).removeClass('open');
				$('.projectDownChevron').rotate({animateTo:0});
			}
			else{
				$(this).addClass('open');
				$('.projectDownChevron').rotate({animateTo:-180});
			}
		});

		$('.projectBackButton').hover(function(){
			$('.projectBackButton.orange').removeClass('hidden');
			$('.projectBackButton.black').addClass('hidden');
		}, function(){
			$('.projectBackButton.black').removeClass('hidden');
			$('.projectBackButton.orange').addClass('hidden');
		});

		$('.projectBackButton').on('click', function(){
			window.history.back();
		});

		$( ".front-page-nav" ).hover(
			function() {
				$(".overlay").addClass('active');
				$(".logo.active").removeClass('active');
				$(".logo.hover").addClass('active');
			},
			function(){
				$(".overlay").removeClass('active');
				$(".logo.active").removeClass('active');
				$(".logo.default").addClass('active');
			}
		);

	$('a[href*="#"]:not([href="#"]), .menu-item a').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - 148
				}, 1000);
				return false;
			}
		}
	});

	$('.workImage').on('click', function(e){
		var url = $(this).attr('data-url');
		console.log(url);
		window.location.href = url;
	});

	$('.mobileNavIcon').on('click', function(e){
		$(this).find('img').toggleClass('open');
		$('.nav').slideToggle();
	});

	// if($('.inViewAnchor').length > 0){
	// 	var distance = $('.inViewAnchor').offset().top + 600,
	//     $window = $(window);

	// 	$window.scroll(function() {
	// 	    if ( $window.scrollTop() >= distance ) {
	// 	        // Your div has reached the top
	// 	        $('.floatingDownChevron').addClass('hidden');
	// 	    }
	// 		else{
	// 			$('.floatingDownChevron').removeClass('hidden');
	// 		}
	// 	});
	// }
	if($('.floatingDownChevron').length > 0){
		$(window).scroll(function () {
			if ($(window).scrollTop() >= $(document).height() - $(window).height() - 300) {
				$('.floatingDownChevron').addClass('hidden');
			}
			else{
				$('.floatingDownChevron').removeClass('hidden');
			}
		});
	}

	$('.contentColumn img').on('click', function(){
		var scrollTop     = $(window).scrollTop(),
    elementOffset = $(this).offset().top,
    distance      = (elementOffset - scrollTop);
		console.log('image click', distance);
		_this = $(this);
		$('html, body').animate({ scrollTop: elementOffset + ($(this).prop("scrollHeight")/2)}, 1000);
	});

	}
};

var $ = jQuery.noConflict();
$(document).ready(function() {

	app.init();

	var smoothState = $('#main').smoothState({
		onStart: {
			// How long this animation takes
			duration: 500,
			// A function that dictates the animations that take place
			render: function ($container) {
				$("#main").addClass('hidden');
			}
		},
		onReady: {
			duration: 0,
			// `$container` is a `jQuery Object` of the the current smoothState container
			// `$newContent` is a `jQuery Object` of the HTML that should replace the existing container's HTML.
			render: function ($container, $newContent) {
				// Update the HTML on the page

				$container.html($newContent);
				$("#main").removeClass('hidden');

				app.init();
				document.body.scrollTop = document.documentElement.scrollTop = 0;
	    	}
		}
	});

	// $('.frontPageBigLink').on('click', function(){
	// 	smoothState.load('/work');
	// });

	// $( ".nav" ).hover(
	// 	function() {
	// 		$("ul.sub-menu.work").addClass('finalPosition');
	// 	},
	// 	function(){
	// 		$("ul.sub-menu").removeClass('finalPosition');
	// 	}
	// );
	//
	// $( ".hasSubMenu a" ).hover(
	// 	function() {
	// 		var subMenu = $(this).parent().attr('data-sub-menu');
	// 		console.log('in '+subMenu);
	// 		$("ul.sub-menu."+subMenu).addClass('finalPosition');
	// 	},
	// 	function(){
	// 		var subMenu = $(this).parent().attr('data-sub-menu');
	// 		console.log('out '+subMenu);
	// 		$("ul.sub-menu."+subMenu).removeClass('finalPosition');
	// 	}
	// );

 });



//////////////////
// WEBPACK FOOTER
// ./src/js/scripts.js
// module id = 0
// module chunks = 0